import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PapiEditorText } from '@wix/da-papi-types';
import LegacyTextRenderer from '@wix/da-shared-react/pkg/TextRenderer/LegacyTextRenderer';
import { pushConfirmationModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { EditorState } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import { extConfigFullscreen } from '@wix/da-editor-tiptap/pkg/components/Editor/presets/DeviationDescription/config';

import s from './LegacyDescriptionEditor.scss';

export interface Props {
  descriptionHtml: PapiEditorText['html'];
  onConvertToDraft: (editorState: EditorState) => void;
}

const LegacyDescriptionEditor: React.FC<Props> = ({ descriptionHtml, onConvertToDraft }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClick = useCallback(
    () =>
      dispatch(
        pushConfirmationModal({
          title: t('deviationSubmit.form.description.convertConfirmModal.title'),
          text: t('deviationSubmit.form.description.convertConfirmModal.message') as string,
          confirmBtnLabel: t('deviationSubmit.form.description.convertConfirmModal.confirm'),
          confirmBtnType: 'danger',
          onConfirm: async () => {
            const mod = await import(
              /* webpackChunkName: "editor_v3", webpackPrefetch: true */ '@wix/da-editor-tiptap/pkg/converters/fromWriterHtml'
            );
            const config = extConfigFullscreen;
            onConvertToDraft(mod.fromWriterHtml(descriptionHtml.markup ?? '', config));
          },
        })
      ),
    [dispatch, t, onConvertToDraft, descriptionHtml.markup]
  );

  return (
    <div className={s['root']} onClick={handleClick}>
      <LegacyTextRenderer html={descriptionHtml.markup} />
    </div>
  );
};
LegacyDescriptionEditor.displayName = 'LegacyDescriptionEditor';

export default LegacyDescriptionEditor;
